import React from "react";
import { SettingsProvider } from "./Provider";
import styles from './layout.module.css';
import NavigationTabs from "../navigation/navigationTab/NavigationTabs";
import { useSearch } from "wouter";
import useFeatureFlag from "@/hooks/useFeatureflag";
import { useUserContext } from "@/contexts/UserContext";
import { AssistantPermissions, UserRole } from "@boxem/core-api-schema";

export default function SettingsLayout({ children }: { children: React.ReactNode }) {
  const { user } = useUserContext();
  const launchSideBar = useFeatureFlag("newSideBar");
  const userPermissions = (user?.sellers?.length > 0 && user.sellers[0].permissions) || 0;
  const assistantHasCreateShipmentPermissions = user?.role === UserRole.ASSISTANT ? (userPermissions & AssistantPermissions.CREATE_SHIPMENTS_PERMISSION) > 0 : true;

  return (
    <SettingsProvider>
      <div className={
        launchSideBar ? styles.containerMaxWidth : styles.container
      }>
        {launchSideBar && <NavigationTabs 
          tabs={assistantHasCreateShipmentPermissions ? [
            { id: 'shipments', label: 'Shipments', href: '/details' },
            { id: 'printing', label: 'Printing', href: '/printing' },
            { id: 'skuOptions', label: 'SKU Options', href: '/variable_sku' },
            { id: 'integrations', label: 'Integrations', href: '/integration' },
          ] : [
            { id: 'shipments', label: 'Shipments', href: '/details' },
            { id: 'printing', label: 'Printing', href: '/printing' },
            { id: 'integrations', label: 'Integrations', href: '/integration' },
          ]}
        />}
        {children}
      </div>
    </SettingsProvider>
  );
}
